import React, { useContext } from 'react';
import styles from './index.scss';
import ThemeContext from '../../../helpers/ThemeContext';
import { OnboardingContext, STEPS } from '../../../OnboardingContext';
import { useHistory } from 'react-router-dom';
import { DisplaySwatch } from '../../../../components/PreviewPage/ThemeCardComponents/ThemeCardSwatch';
import { onboardingDesignPDPRoute } from '../../../../helpers/routes';

const Footer = () => {
  const history = useHistory();
  const { currentTheme, currentColorway } = useContext(ThemeContext);
  const { step } = useContext(OnboardingContext);

  const shouldRenderColorSwatch = step === STEPS.BASIC_INFO;

  return (
    <div className={styles.footer}>
      <div className={styles.themeName}>{currentColorway?.name || ''}</div>

      {shouldRenderColorSwatch && (
        <div className={styles.footer__colorSwatchWrapper}>
          <DisplaySwatch
            themeFamily={currentTheme}
            onClick={themeId => {
              history.replace(onboardingDesignPDPRoute(themeId));
            }}
            selected={currentColorway?.id}
            isCenterAligned
          />
        </div>
      )}
    </div>
  );
};

export default Footer;
